import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import {  IDropdownSettings } from 'ng-multiselect-dropdown';
@Component({
  selector: 'app-filter-component',
  templateUrl: './filter-component.component.html',
  styleUrls: ['./filter-component.component.scss']
})
export class FilterComponentComponent implements OnInit {

  filterParams: any = {};
  selectedRegions: any =[];
  dropdownSettings :IDropdownSettings;
  // channels: any =[];
  // user_roles: any =[];
  // geography: any =[];
  filteredDetails:any = {
    regions:[],
    channels:[],
    user_roles:[],
    geography:[]
  }
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    ) { }

  ngOnInit() {
    this.getAllFilterParams();



  }

  getAllFilterParams(){
    this.apiService.get(this.apiConfig.filterDataParams)
    .subscribe((res:any)=>{
      this.filterParams = res.data;
    },err=>{
      console.log(err);
    })
  }

  selectedItem(e,id){
    console.log(e);
    switch (id) {
      case 1:
        this.filteredDetails.regions = e;
        break;
      case 2:
        this.filteredDetails.channels = e;
        break;
      case 3:
        this.filteredDetails.user_roles = e;
        break;
      case 4:
        this.filteredDetails.geography = e;
        break;
      default:
        break;
    }
  }
  filter(){
    console.log(this.filteredDetails);
  }

}
